import type { HeaderViewService } from 'components/organisms/header-v2/service/header-view.service';
import type { ILandingPage } from 'src/pages/layouts/entities/types';
import type { LayoutService } from 'src/pages/layouts/services/layout.service';

export function applyHeaderConfigFromViewData(
    headerViewService: HeaderViewService,
    layoutService: LayoutService,
    viewData: ILandingPage
): void {
    const layout = viewData?.layout;

    if (!layout) {
        return;
    }

    layoutService.setHeaderType(layout.header_type);
    headerViewService.setHeaderType(layout.header_type);

    const isFullHeader = layout.header_type === 'full';

    layoutService.setHeaderData(isFullHeader ? (layout.menu_data ?? []) : null);

    if (isFullHeader) {
        headerViewService.initThemes(layout.first_widget_color, layout.header_color);
    }

    if (layout.header_settings?.header_logo_light) {
        headerViewService.logoLight = layout.header_settings.header_logo_light;
    }

    if (layout.header_settings?.header_alt_logo_light) {
        headerViewService.logoLightAlt = layout.header_settings.header_alt_logo_light;
    }

    if (layout.header_settings?.header_logo_dark) {
        headerViewService.logoDark = layout.header_settings.header_logo_dark;
    }

    if (layout.header_settings?.header_alt_logo_dark) {
        headerViewService.logoDarkAlt = layout.header_settings.header_alt_logo_dark;
    }

    if (layout.header_settings?.header_logo_url) {
        headerViewService.logoUrl = layout.header_settings.header_logo_url;
    }

    if (layout.header_settings?.hide_right_side) {
        headerViewService.hideRightSide = true;
    } else {
        headerViewService.hideRightSide = false;
    }

    if (layout.header_settings?.registration_form) {
        headerViewService.registrationForm = layout.header_settings.registration_form;
    }

    if (layout.is_header_stickiness_disabled) {
        headerViewService.toggleHeaderStickiness(layout.is_header_stickiness_disabled);
    }
}
